import { Skeleton } from '@mui/material';

import {
  MenuButton,
  ReleaseButtonSlot,
  StudioButtonSlot,
  TrackAddToLibrary,
  TrackCopyLink,
  TrackDownload,
  TrackDuration,
  TrackProgress,
  TrackTitle,
} from '../TrackGrid';
import { StyledTrackGrid } from '../TrackContent/styled';
import {
  StyledDurationSkeleton,
  StyledPlaybackSkeleton,
  StyledTitleSkeleton,
  StyledTrackPlayback,
} from './styled';

const TrackLoader = () => (
  <StyledTrackGrid>
    <StyledTrackPlayback>
      <StyledPlaybackSkeleton />
    </StyledTrackPlayback>
    <TrackTitle>
      <StyledTitleSkeleton data-testid="track-title" />
    </TrackTitle>
    <TrackDuration>
      <StyledDurationSkeleton />
    </TrackDuration>
    <TrackProgress>
      <Skeleton variant="rectangular" />
    </TrackProgress>
    <StudioButtonSlot>
      <Skeleton variant="rectangular" />
    </StudioButtonSlot>
    <ReleaseButtonSlot>
      <Skeleton variant="rectangular" />
    </ReleaseButtonSlot>
    <TrackCopyLink>
      <Skeleton variant="rectangular" />
    </TrackCopyLink>
    <TrackAddToLibrary>
      <Skeleton variant="rectangular" />
    </TrackAddToLibrary>
    <TrackDownload>
      <Skeleton variant="rectangular" />
    </TrackDownload>
    <MenuButton>
      <Skeleton variant="rectangular" />
    </MenuButton>
  </StyledTrackGrid>
);

export default TrackLoader;
